import { useState } from "react";
import { Button } from "@/components/ui/button";
import { toast } from "@/components/ui/use-toast";
import { supabase } from "../../supabase/supabase";

export default function RunMigrationButton() {
  const [isRunning, setIsRunning] = useState(false);

  const runMigration = async () => {
    setIsRunning(true);
    try {
      const session = await supabase.auth.getSession();
      if (!session.data.session) {
        throw new Error("No active session");
      }

      const response = await fetch(
        `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/run_migration`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${session.data.session.access_token}`,
          },
        },
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Failed to run migration");
      }

      toast({
        title: "Success",
        description: "Provider credentials table created successfully",
      });

      // Reload the page to refresh the data
      window.location.reload();
    } catch (error) {
      console.error("Error running migration:", error);
      toast({
        title: "Error",
        description: error.message || "Failed to run migration",
        variant: "destructive",
      });
    } finally {
      setIsRunning(false);
    }
  };

  return (
    <Button onClick={runMigration} disabled={isRunning}>
      {isRunning
        ? "Running Migration..."
        : "Run Provider Credentials Migration"}
    </Button>
  );
}
